export default __webpack_public_path__ + "static/comparison-85eeb63cc17aa36b84bb8e9f7144090c.png";